import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';

export default createReactClass({
	propTypes: {
		data: PropTypes.object,
		active: PropTypes.bool
	},

	render() {
		let itemClass = 'slx-datalist__li';
		if (this.props.active) {
			itemClass += ' active';
		}
		return (
			<li className={itemClass}>
				<h4 className="slx-datalist__label">
					<a href={this.props.data.url}>{this.props.data.title}</a>
				</h4>
			</li>
		);
	}
});
